































































































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import {
  policyStatus, billingType, payerType, policyStatusClass, statusValues, billingTypeValues
} from '@/modules/Policy/helpers/policy'
import { caseTypeToVerb } from '@/modules/Case/helpers/case'
import { updatePolicyNonRenew, updatePolicyCancelDate, updatePolicyBorDate } from '@/modules/Policy/gql/policy.gql'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { SnackType } from '@/interfaces/snack'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { showErrors, showNotification } from '@/utils/snack'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AcordFormDialog from '@/components/AcordFormDialog.vue'
import AppCheckBox from '@/components/AppCheckbox.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { User } from '@/modules/User/interfaces/user'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import SearchAccount from '@/mixins/search-queries/search-account'
import SearchContact from '@/mixins/search-queries/search-contact'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import SearchUser from '@/mixins/search-queries/search-user'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import SearchProducer from '@/mixins/search-queries/search-producer'
import SearchGA from '@/mixins/search-queries/search-ga'
import SearchQuote from '@/mixins/search-queries/search-quote'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import SearchBook from '@/mixins/search-queries/search-book'
import { newCase } from '@/modules/Case/gql/case.gql'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AcordFormDialog,
    AppSystemInfoCard,
    AppCheckBox,
    AppDatePicker
  }
})
export default class PolicyDetailDetail extends mixins(PolicyDialog, mixins(SearchQuote, SearchCarrier, SearchGA, SearchUser, SearchProducer), mixins(SearchAccount, SearchContact, SearchPolicy, SearchCarrierProduct, SearchBook)) {
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType
  @Prop({ type: Object as () => { [key: string]: any; } }) readonly additionalInput!: { [key: string]: any; }

  policyInput: {
    [key: string]: any;
  } = {
    nonRenew: false,
    autoCancel: false,
    cancelDate: '',
    borDate: '',
    autoBor: false
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  caseTypeToVerb = caseTypeToVerb
  dollarFilter = dollarFilter
  policyStatus = policyStatus
  billingType = billingType
  payerType = payerType
  billingTypeOptions = billingTypeValues
  policyStatusClass = policyStatusClass
  statusOptions = statusValues

  acordFormDialog = {
    show: false
  }

  renewDialog = {
    show: false
  }

  nonRenewDialog = {
    show: false
  }

  autoCancelDialog = {
    show: false
  }

  autoBorDialog = {
    show: false
  }

  additionalInfoCards: {
    title: string;
    items: {[key: string]: any;}[]
  }[] = []

  policyAdditional: {
    [key: string]: any;
  } = {}

  @State(state => state.user.me) me!: User

  get premiumType () {
    return this.policy.generalAgent
      ? 'ga'
      : 'direct'
  }

  get priorTermRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.policy.inheritPolicies.fromPolicy
          ? this.policy.inheritPolicies.fromPolicy.id
          : null
      }
    }
  }

  get postTermRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.policy.inheritPolicies.toPolicy
          ? this.policy.inheritPolicies.toPolicy.id
          : null
      }
    }
  }

  get quoteRoute () {
    return {
      name: 'QuoteDetailDetail',
      params: {
        id: this.policy.insuranceQuote.id
      }
    }
  }

  get accountRoute () {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: this.policy.account.id
      }
    }
  }

  get contactRoute () {
    return {
      name: 'ContactDetailDetail',
      params: {
        id: this.policy.primaryContact.id
      }
    }
  }

  get carrierRoute () {
    return {
      name: 'CarrierDetailDetail',
      params: {
        id: this.policy.carrier.id
      }
    }
  }

  get gaRoute () {
    return {
      name: 'GeneralAgentDetailDetail',
      params: {
        id: this.policy.carrier.id
      }
    }
  }

  get carrierProductRoute () {
    return {
      name: 'CarrierProductDetailDetail',
      params: {
        id: this.policy.carrierProduct.id
      }
    }
  }

  get totalProjectedPremium () {
    let totalNum = 0
    if (this.policy) {
      const { premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, taxesFee, brokerFee } = this.policy
      const premiumNum = premium ? Number(premium) : 0
      const agencyFeeNum = agencyFee ? Number(agencyFee) : 0
      const carrierPolicyFeeNum = carrierPolicyFee ? Number(carrierPolicyFee) : 0
      const inspectionFeeNum = inspectionFee ? Number(inspectionFee) : 0
      const stampingFeeNum = stampingFee ? Number(stampingFee) : 0
      const taxesFeeNum = taxesFee ? Number(taxesFee) : 0
      const brokerFeeNum = brokerFee ? Number(brokerFee) : 0
      totalNum = Number((premiumNum + agencyFeeNum + carrierPolicyFeeNum + inspectionFeeNum + stampingFeeNum + taxesFeeNum + brokerFeeNum).toFixed(2))
    }
    return totalNum
  }

  get totalProjectedCommission () {
    let totalNum = '0.00'
    if (this.policy) {
      const { premium, productCommissionOverride } = this.policy

      if (premium && productCommissionOverride && !isNaN(Number(productCommissionOverride))) {
        totalNum = (Number(premium) * Number(productCommissionOverride) / 100).toFixed(2)
      }
    }
    return totalNum
  }

  get showRenewButton () {
    return !this.policy.inheritPolicies.toPolicy
  }

  @Watch('policy', { deep: true })
  onPolicyUpdated (val: Policy) {
    this.policyInput.nonRenew = val.nonRenew
    this.policyInput.autoCancel = val.shouldAutoCancel
    this.policyInput.autoBor = val.shouldAutoBor
    this.policyInput.cancelDate = val.cancelDate
    this.onRecordTypeChanged(this.recordType)
  }

  @Watch('recordType', { deep: true })
  onRecordTypeChanged (val: RecordType) {
    this.additionalInfoCards = val.additionalInfo
    this.policyAdditional = JSON.parse(this.policy.additionalInfoStr)
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  @Emit('edit')
  editPolicy (step: number) {
    return step
  }

  async mounted () {
    this.onPolicyUpdated(this.policy)
  }

  showAcordFormDialog (e: Event, targetPolicy: Policy) {
    e.preventDefault()
    e.stopPropagation()

    this.acordFormDialog.show = true
  }
  hideAcordFormDialog () {
    this.acordFormDialog.show = false
  }

  showRenewDialog (e: Event) {
    e.preventDefault()
    e.stopPropagation()

    this.renewDialog.show = true
  }

  hideRenewDialog () {
    this.renewDialog.show = false
  }

  clearPolicyInput () {
    this.policyInput = {
      nonRenew: false,
      autoCancel: false,
      cancelDate: ''
    }
  }

  async reCaseConfirm () {
    const {
      policyName, id, recordType, account, primaryContact,
      source
    } = this.policy as Policy

    this.renewDialog.show = false
    const year = this.$moment.tz('America/New_York').year()

    try {
      const res = await this.$apollo.mutate({
        mutation: newCase,
        variables: {
          caseInput: {
            inquiryName: `${account.name}-${recordType.name}-Policy-Renew-${year}`,
            type: 'RENEWAL',
            targetPolicyId: Number(id),
            caseNote: 'Renewal case for policy: ' + policyName,
            recordTypeId: Number(recordType.id),
            accountId: Number(account.id),
            primaryContactId: primaryContact ? Number(primaryContact.id) : null,
            caseManagerId: Number(this.me.id),
            sourceId: source ? Number(source.id) : null
          }
        }
      })
      showNotification({
        msg: 'Create renewal case successfully',
        type: SnackType.Success
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.onSuccess()
  }

  async updateNonRenewPost () {
    const {
      nonRenew
    } = this.policyInput

    this.nonRenewDialog.show = false

    try {
      const res = await this.$apollo.mutate({
        mutation: updatePolicyNonRenew,
        variables: {
          policyId: Number(this.policy.id),
          nonRenew
        }
      })
      showNotification({
        msg: 'Update policy "non-renew" successfully',
        type: SnackType.Success
      })
      this.clearPolicyInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateAutoCancelPost () {
    const {
      autoCancel,
      cancelDate
    } = this.policyInput

    if (autoCancel) {
      const autoCancelValid = (this.$refs.autoCancel as Vue & { validate: () => boolean }).validate()

      if (!autoCancelValid) {
        return
      }
    }

    this.autoCancelDialog.show = false

    try {
      const res = await this.$apollo.mutate({
        mutation: updatePolicyCancelDate,
        variables: {
          policyId: Number(this.policy.id),
          autoCancel,
          cancelDate: cancelDate ? cancelDate.toString() : ''
        }
      })
      showNotification({
        msg: 'Update policy auto cancel date successfully',
        type: SnackType.Success
      })
      this.clearPolicyInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateAutoBorPost () {
    const {
      autoBor,
      borDate
    } = this.policyInput

    if (autoBor) {
      const autoBorValid = (this.$refs.autoBor as Vue & { validate: () => boolean }).validate()

      if (!autoBorValid) {
        return
      }
    }

    this.autoBorDialog.show = false

    try {
      const res = await this.$apollo.mutate({
        mutation: updatePolicyBorDate,
        variables: {
          policyId: Number(this.policy.id),
          autoBor,
          borDate: borDate ? borDate.toString() : ''
        }
      })
      showNotification({
        msg: 'Update policy BOR date successfully',
        type: SnackType.Success
      })
      this.clearPolicyInput()
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
